// StatusChip.js — Semantic status chip. The ONLY way to show record status.
//
// Color semantics (from tokens):
//   success (green #15803D)  — approved/paid/active/completed/positive
//   warning (amber #B45309)  — pending/needs-attention
//   error   (red #B91C1C)    — rejected/failed/overdue/destructive
//   neutral (gray)           — draft/inactive/archived/unknown
//   primary (blue #1D4ED8)   — in-progress/active-process states only
//
// Labels are auto-humanized from the raw status slug via formatEnumLabel.
import React from 'react';
import { Chip } from '@mui/material';
import { formatEnumLabel } from '../../utils/formatters';

const STATUS_COLOR = {
  // success
  approved: 'success',
  manager_approved: 'success',
  fully_paid: 'success',
  paid: 'success',
  active: 'success',
  completed: 'success',
  complete: 'success',
  settled: 'success',
  success: 'success',
  released: 'success',
  present: 'success',
  resolved: 'success',
  verified: 'success',
  sufficient: 'success',
  // warning
  outstanding: 'warning',
  overpayment: 'warning',
  pending: 'warning',
  pending_approval: 'warning',
  pending_payment: 'warning',
  partial: 'warning',
  partially_paid: 'warning',
  processing: 'warning',
  on_hold: 'warning',
  expiring_soon: 'warning',
  low: 'warning',
  // error
  rejected: 'error',
  failed: 'error',
  overdue: 'error',
  cancelled: 'error',
  canceled: 'error',
  deleted: 'error',
  suspended: 'error',
  empty: 'error',
  deficit: 'error',
  // primary (active process states)
  in_progress: 'primary',
  ongoing: 'primary',
  // neutral
  draft: 'default',
  inactive: 'default',
  archived: 'default',
  resigned: 'default',
  terminated: 'default',
};

export default function StatusChip({ status, label, color, size = 'small', sx = {} }) {
  const key = String(status || '').toLowerCase();
  const resolvedColor = color || STATUS_COLOR[key] || 'default';
  return (
    <Chip
      size={size}
      color={resolvedColor === 'default' ? 'default' : resolvedColor}
      label={label || formatEnumLabel(status)}
      sx={{
        fontWeight: 500,
        ...(resolvedColor === 'default' && {
          bgcolor: 'grey.100',
          color: 'grey.700',
        }),
        ...sx,
      }}
    />
  );
}
